
export { MinRetentionRuleFrequencyEnum } from "/codebuild/output/src2614373214/src/actions-runner/_work/eon-service/eon-service/frontend/packages/api-gw-sdk/dist/models/MinRetentionRule.js"